const { REACT_APP_DOMAIN = '' } = process.env;

export { REACT_APP_DOMAIN };
